/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
(function() {

  class TwoColumnWithTextOverlay extends HTMLElement {
    constructor() {
      super();
    }
  }
  window.customElements.define('two-column-with-text-overlay', TwoColumnWithTextOverlay);
  /*============================================================================
    Money Format
    - Shopify.format money is defined in option_selection.js.
      If that file is not included, it is redefined here.
  ==============================================================================*/
  if ((typeof Shopify) === 'undefined') { Shopify = {}; }
  if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
      var value = '',
          placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = (format || this.money_format);

      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    };
  }
  /*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

  ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      console.log(data.message + '(' + data.status  + '): ' + data.description);
    }
  };

  // -------------------------------------------------------------------------------------
  // POST to cart/add.js returns the JSON of the line item associated with the added item.
  // -------------------------------------------------------------------------------------
  ShopifyAPI.addItem = function(variant_id, quantity, callback) {
    var quantity = quantity || 1;
    const drawer = document.querySelector('[data-drawer="drawer-cart"]'); // ALEX C - 2023 - OPEN CART DRAWER ON ADD TO CART
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      success: function(response) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
        drawer.dispatchEvent(
          new CustomEvent('theme:drawer:open', {
            bubbles: false,
          })
        );
        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      },
      error: function(XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
  };


  // POST to cart/change.js returns the cart in JSON
  ShopifyAPI.changeItemVariant = function(variant_id, quantity, callback) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity='+quantity+'&id='+variant_id,
      dataType: 'json',
      success: function(response) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      },
      error: function(XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
  };

  function cartGiftBag() {

    const gift_bag_variant_id = 40404422557765;
  
    const input = document.querySelector('#gift-bag-atc');
    input.addEventListener('click', saveGiftBag, false);
  
    function saveGiftBag(event) {
      event.preventDefault();
        $.post({ 
        url: '/cart/add.js',
        data: {
          items: [{
              quantity: 1,
              id: gift_bag_variant_id
          }]
        },
        dataType: 'json',
        success: function(response) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: {
                cart: response.data,
              },
              bubbles: true,
            })
          );
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
        }
      });
    }
  
    function checkCartGiftBag(cart){
      var cartHasGiftBag = !!cart.items.find(function(item){
        return item.variant_id === gift_bag_variant_id;
      });
      if (cartHasGiftBag) {
        $('.gift_bag_holder').addClass('is-hidden');
      } else {
        $('.gift_bag_holder').removeClass('is-hidden');
      }
    }
  
    document.addEventListener('theme:cart:change', function(event) {
      var cart = event.detail.cart;
      if (cart) {
        // check cart gift bag status
        checkCartGiftBag(cart);
      }
    });
  
  }

function quickAdd(ev){
  ev.preventDefault();
  ShopifyAPI.addItem(this.dataset.variantId, 1);
}

// Toggle product models
function toggleProductModels() {
    var $duneCollection = document.getElementById('dune-collection');
    var $images = document.getElementsByClassName('product-grid-item__image');
    document.querySelectorAll('.collection__product-images-option').forEach(function($item, i){
        $item.addEventListener('click', function(e) {
            $item.parentElement.querySelectorAll('.collection__product-images-option').forEach(function($sibling, i){
                $sibling.classList.remove('collection__product-images-option--active');
            });
            $item.classList.add('collection__product-images-option--active');
            if ($item.dataset.toggleProductImages == 'models') {
                $duneCollection.classList.add('js-show-models');
                Array.from($images).forEach(function($image){
                  if ($image.classList.contains('model-image')){
                    $image.classList.add('is-active');
                  } else {
                    $image.classList.remove('is-active');
                  }
                })
            } else {
                $duneCollection.classList.remove('js-show-models');
                Array.from($images).forEach(function($image){
                  if ($image.classList.contains('product-image')){
                    $image.classList.add('is-active');
                  } else {
                    $image.classList.remove('is-active');
                  }
                })
            }
        })
    });
}

function remove_ng_swatches() {
  const filter_button = document.querySelector('.collection__filters__toggle');
  if (filter_button) {
    filter_button.addEventListener('click', (e) => {
      let ng_swatch = document.querySelector('.sidebar__navigation__list .swatch__button radio-swatch label[data-swatch="ng"]');
      if (ng_swatch) {
        ng_swatch.parentElement.parentElement.remove() 
      }
    });
  }
}

function currencySelector() {
    const $dropdownToggle = document.querySelector('.dropdown-toggle')
    const $mobileDropdownToggle = document.querySelector('#flagclick')
    const $mobileDropdownFlag = document.querySelector('#nextflag')
    // Dropdown toggle
    $dropdownToggle.addEventListener('click', function (e) {
        $(this).next('.dropdown').toggle();
    });
    // Dropdown toggle
    $mobileDropdownToggle.addEventListener('click', function (e) {
       e.preventDefault()
        $("#nextflag").slideToggle();
    });
    $mobileDropdownFlag.addEventListener('click', function (e) {
       e.preventDefault()
        window.location.href = 'https://deandavidsonus.myshopify.com';
    });
    document.addEventListener('click', function (e) {
        var target = e.target;
        if (!$(target).is('.dropdown-toggle') && !$(target).parents().is('.dropdown-toggle')) {
          $('.dropdown').hide();
        }
        if (!$(target).is('#flagclick') && !$(target).parents().is('#flagclick') && !$(target).is('#nextflag')) {
          $('#nextflag').slideUp();
        }
    });
};

document.addEventListener('theme:variant:hover:enter', function(event) {
  var gemstone = document.querySelector('[data-swapper-gemstone]');
  var productSection = document.querySelector('.product-section');
  if (gemstone && productSection){
    var productHandle = productSection.dataset.productHandle;
    if (productHandle == "plaza-ring-gold-lavender-haze" && theme.strings.manMadeGemstones.includes(event.detail.hover)){
      gemstone.innerHTML = "Man-Made";
    } else if (productHandle == "signature-midi-knockout-studs-gold-lavender-haze" && theme.strings.semiPreciousGemstones.includes(event.detail.hover)){
      gemstone.innerHTML = "Semi-Precious";
    } else if (theme.strings.manMadeGemstones.includes(event.detail.hover)){
      gemstone.innerHTML = "Man-Made";
    } else if (theme.strings.semiPreciousGemstones.includes(event.detail.hover)) {
      gemstone.innerHTML = "Semi-Precious";
    } else {
      gemstone.innerHTML = "";
    }
  }
});

document.addEventListener('theme:variant:hover:exit', function(event) {
  var gemstone = document.querySelector('[data-swapper-gemstone]');
  var productSection = document.querySelector('.product-section');
  if (gemstone && productSection){
    var productHandle = productSection.dataset.productHandle;
    if (productHandle == "plaza-ring-gold-lavender-haze" && theme.strings.manMadeGemstones.includes(event.detail.hover)){
      gemstone.innerHTML = "Man-Made";
    } else if (productHandle == "signature-midi-knockout-studs-gold-lavender-haze" && theme.strings.semiPreciousGemstones.includes(event.detail.hover)){
      gemstone.innerHTML = "Semi-Precious";
    } else if (theme.strings.manMadeGemstones.includes(event.detail.hover)){
      gemstone.innerHTML = "Man-Made";
    } else if (theme.strings.semiPreciousGemstones.includes(event.detail.hover)) {
      gemstone.innerHTML = "Semi-Precious";
    } else {
      gemstone.innerHTML = "";
    }
  }
});

document.querySelectorAll('.quick_add_btn').forEach(item => {
  item.addEventListener('click', quickAdd);
});

// Function that actually builds the swiper 
const buildProductSwiperSlider = sliderElm => {
  const sliderIdentifier = sliderElm.id;
  const sliderLimit = sliderElm.dataset.limit;
  let sliderLimitL = 0;
  let sliderLimitXL = 0;
  if (sliderLimit <= 4) {
    sliderLimitL = sliderLimit;
  } else { 
    sliderLimitL = 5 
  }
  if (sliderLimit <= 5) {
    sliderLimitXL = sliderLimit;
  } else { 
    sliderLimitXL = 6
  }

  return new Swiper(`#${sliderIdentifier}`, {
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
      },
      // Optional parameters
      slidesPerView: 2,
      spaceBetween: 20,
      cssMode: true,
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 3,
        },
        // when window width is >= 1080px
        1080: {
          slidesPerView: sliderLimitL,
        },
        // when window width is >= 1920px
        1920: {
          slidesPerView: sliderLimitXL,
        }
      }
  });
}
const buildCollectionSwiperSlider = sliderElm => {
  const sliderIdentifier = sliderElm.id;
  const sliderLimit = sliderElm.dataset.limit;
  let sliderLimitL = 0;
  let sliderLimitXL = 0;
  if (sliderLimit <= 4) {
    sliderLimitL = sliderLimit;
  } else { 
    sliderLimitL = 4
  }
  if (sliderLimit <= 5) {
    sliderLimitXL = sliderLimit;
  } else { 
    sliderLimitXL = 4
  }

  return new Swiper(`#${sliderIdentifier}`, {
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
      },
      // Optional parameters
      slidesPerView: 1.2,
      spaceBetween: 5,
      cssMode: true,
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 1080px
        1080: {
          slidesPerView: sliderLimitL,
          spaceBetween: 20,
        },
        // when window width is >= 1920px
        1920: {
          slidesPerView: sliderLimitXL,
          spaceBetween: 20,
        }
      }
  });
}

// Get all of the swipers on the page
const productSliders = document.querySelectorAll('.product-swiper');
const collectionSliders = document.querySelectorAll('.collection-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
productSliders.forEach(slider => buildProductSwiperSlider(slider));
collectionSliders.forEach(slider => buildCollectionSwiperSlider(slider));

currencySelector();
toggleProductModels();
cartGiftBag();
remove_ng_swatches();

})();
